import { LogoutIcon } from '@heroicons/react/solid'
import { Tag } from 'src/components'
import { ItemOf, makeDate } from 'src/utils'
import { elapsedTime } from 'src/utils/date'
import { useLogoutUser, useListActiveUsers } from '../queries'
import CustomButton from 'src/components/Shared/UIComponents/Button'

type Props = {
  user: ItemOf<typeof useListActiveUsers>
  username: string
  organization: string
}

export default function OnlineUsersItem({
  user,
  organization,
  username,
}: Props) {
  const logoutUser = useLogoutUser()

  return (
    <div className="flex flex-row col-span-full">
      <Tag
        label={user.username.slice(0, 1).toUpperCase()}
        color="green"
        className="self-center mr-3"
      />

      <div className="self-center flex-1 mr-2 leading-6 text-slate-700">
        {user.username}
      </div>

      <div className="self-center flex-1 mr-2 text-xs leading-6 text-slate-500">
        Logged in since {makeDate(user.creationtime)}
      </div>

      <div className="self-center flex-1 mr-2 text-xs leading-6 text-slate-500">
        Last activity {elapsedTime(user.lastActivity)}
      </div>

      <div className="flex items-center">
        <CustomButton
          label="Log Out"
          loadingLabel="Log Out"
          onClick={() =>
            logoutUser.mutateAsync({
              username,
              organization,
              usernameforlogout: user.username,
            })
          }
          isLoading={logoutUser.isLoading}
          iconPosition="left"
          icon={<LogoutIcon />}
        />
      </div>
    </div>
  )
}
